import { ArrowDownSVG } from "@components/svgs";
import { SHStack, SHTypography } from "@components/design-systems";

type MSTableFilterSectionTitleProps = {
  title: string;
  isOpen: boolean;
  onClick: () => void;
};

export const MSTableFilterSectionTitle = ({
  onClick,
  isOpen,
  title,
}: MSTableFilterSectionTitleProps) => {
  return (
    <SHStack
      direction={"row"}
      alignItems={"center"}
      gap={1}
      onClick={onClick}
      sx={{
        cursor: "pointer",
      }}
    >
      <SHStack
        marginTop={"-2px"}
        sx={{
          transform: !isOpen ? "rotate(-90deg)" : "rotate(0deg)",
          transition: "transform 0.3s ease",
        }}
      >
        <ArrowDownSVG width={12} height={12} />
      </SHStack>
      <SHTypography
        variant={"body2"}
        fontSize={12}
        fontWeight={600}
        sx={{
          userSelect: "none",
        }}
      >
        {title}
      </SHTypography>
    </SHStack>
  );
};
